import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../../utils/customBaseQuery";
import { PidApiUserType } from "@lxp-app/pages/event-review/Utils/pidApiUserType";

export const UtilityUser = createApi({
  reducerPath: "utilityUser",
  baseQuery: customBaseQuery,
  keepUnusedDataFor: 60,
  endpoints: (builder) => ({
    getUserByKeyApi: builder.query({
      query: (data) => {
        return {
          url: `/utility/users/${data}`,
          method: "GET"
        };
      },
      extraOptions: { service: "Utility" }
    }),
    getEducatorByKeyApi: builder.query({
      query: (data) => {
        return {
          url: `/utility/users/educators/${data.key}`,
          method: "POST",
          body: data.body
        };
      },
      extraOptions: { service: "Utility" }
    }),
    getUserById: builder.mutation({
      query: ({
        pageNumber,
        pageSize,
        sortKey,
        sortOrder,
        data
      }: PidApiUserType) => ({
        url: `/pid/profile/detail/paginated/enable-ignored`,
        method: "POST",
        params: {
          pageNumber: pageNumber || 1,
          pageSize: pageSize || 6,
          sortKey: sortKey || "createdat",
          sortOrder: sortOrder || "DESC"
        },
        body: data
      }),
      extraOptions: { service: "PID" }
    }),
    getVenueByKeyApi: builder.query({
      query: (data) => {
        return {
          url: `/utility/venue/${data}`,
          method: "GET"
        };
      },
      extraOptions: { service: "Utility" }
    }),
    getVenueById: builder.mutation({
      query: (data) => {
        return {
          url: "/utility/venue/fromId",
          method: "POST",
          body: data
        };
      },
      extraOptions: { service: "Utility" }
    }),
    addEducatorsApi: builder.mutation({
      query: (data) => ({
        url: "/resource/add/educators",
        method: "POST",
        body: data
      }),
      extraOptions: { service: "Resource" }
    })
  })
});

export const {
  useLazyGetUserByKeyApiQuery,
  useLazyGetEducatorByKeyApiQuery,
  useGetUserByIdMutation,
  useLazyGetVenueByKeyApiQuery,
  useGetVenueByIdMutation,
  useAddEducatorsApiMutation
} = UtilityUser;
